import Vue from '@triotech/vue-core/src/vendor/vue';
import QS from '@triotech/vue-core/src/vendor/qs';
import I18n from '@triotech/vue-core/src/plugins/i18n';

const Helper = new Vue({
  i18n: I18n,
  computed: {
    isLegacy() {
      return this.$config.get('legacy');
    },
    hasPlayerWeb() {
      return this._.get(this.user(), 'player') === 'playweb';
    },
    hasRolePcie() {
      return this._.get(this.user(), 'role') === this.$roles.PCIE;
    },
    hasRoleEval() {
      return this._.get(this.user(), 'role') === this.$roles.EVAL;
    },
    canDownloadPdf() {
      return this.user().can_download_pdf;
    },
    canShareOnTwitter() {
      return this.user().can_share_on_twitter;
    },
    canShowLanguage() {
      return this.getParameter('show_language');
    },
    canShowPlayerDemo() {
      return this.getParameter('show_player_demo');
    },
    canShowHelpVideo() {
      return this.getParameter('show_help_video');
    },
    showValidatedResult() {
      return this.getParameter('show_validated_result');
    },
    canDisplayOnVerifPcie() {
      return this.getParameter('can_display_on_verifpcie');
    },
    baseUrlVerifPcie() {
      return this.getParameter('base_url_verif_pcie');
    },
    canShareOnFacebook() {
      return this.getParameter('can_share_on_facebook');
    },
    isClientCenter(){
      return this.user().is_client_center
    }
  },
  methods: {
    getEnums() {
      return new Promise((resolve, reject) => {
        const missingEnums = this._.difference(['gender', 'language', 'player', 'studies', 'job'], this._.keys(this.get().enums));
        if (missingEnums.length === 0) {
          resolve(this.get().enums);
        } else {
          Promise.all(missingEnums.map(this.fetchEnums)).then(() => {
            resolve(this.get().enums);
          }).catch(reject);
        }
      });
    },
    fetchEnums(kind) {
      return this.$ajax.publicRequest(`public/enum/${kind}_enum`).then((data) => {
        let { enums } = this.get();
        if (!enums) {
          enums = {};
        }

        enums[kind] = data;
        this.set({ enums });
      });
    },
    setLocale(locale) {
      const [shortLocale] = locale.toLowerCase().match(/([a-z]+)/) || [];

      if (shortLocale) {
        this.$i18n.locale = shortLocale;
        this.$moment.locale(shortLocale);
      }
    },
    getParameter(key) {
      const { parameters } = this.get();
      return this._.get(parameters, `${key}.value`);
    },
    playerFullUri(career, qs) {
      const playerUri = this.getParameter('player') || null;
      const token = this.get().oauth ? this.get().oauth.access_token : null;

      if (playerUri) {
        return `${playerUri}?${QS.stringify(this._.pickBy({ token, career, ...qs }, this._.identity))}`;
      }

      return '#';
    },
    getImage(fileName) {
      if (this.isLegacy) {
        return `${this.$config.get('host')}${fileName}`;
      }

      return this.$ajax.getUploadsUri(`/images/${fileName}`);
    },
    formatDate(date, format = 'L') {
      return this.$moment(date).format(format);
    },
    swapObjKeyValue(obj, translation = false) {
      const ret = {};
      Object.keys(obj).forEach((key) => {
        const keyValue = translation ? this.$t(key) : key;
        ret[keyValue] = key;
      });
      return ret;
    },
    async popupHide() {
      await this.$ajax.patch('user/me/popup', { popup: false }).then(() => {
        const oauth = this.oauth();
        oauth.user.popup = false;

        this.set({ oauth });
      });
    },
  },
});

Vue.set(Vue.prototype, '$helper', Helper);

export default Helper;
